// extracted by mini-css-extract-plugin
export var discard = "_2n-3";
export var muiTooltipTooltip = "_2n-5";
export var notificationBar = "_2n-2";
export var saveButtonHoverSlotWrapper = "_2n-4";
export var show = "_2n-1";
export var spacer = "_2n-0";